function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var Legroom = function Legroom(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17L14.2687 18.6292C14.3059 18.708 14.3388 18.7894 14.3577 18.8745C14.5977 19.954 13.7765 21.0005 12.6484 21.0005H5.00049M21 7H10M21 7L19 5M21 7L19 9M10 7L12 5M10 7L12 9M5.94752 4.1057C5.72955 3.30646 4.90494 2.83526 4.1057 3.05323C3.30646 3.2712 2.83526 4.09582 3.05323 4.89505L6.00299 15.7108C6.21063 16.4722 6.90216 17.0004 7.69133 17.0004H14.5004C15.3288 17.0004 16.0004 16.3288 16.0004 15.5004C16.0004 14.6719 15.3288 14.0004 14.5004 14.0004H9.02797C8.80249 14.0004 8.60491 13.8495 8.54559 13.6319L5.94752 4.1057Z",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};